<script>  
  let isOpen = false;  
  let SupportText ;
  const toggle = () => {   

    navigator.clipboard.writeText('0xf8E9F10c22840b613cdA05A0c5Fdb59A4d6cd7eF')
    .then(() => {
      isOpen = true;
      SupportText = "Copied!";
      setTimeout(function() {
        isOpen = false;
      }, 3000);            
    })
    .catch(err => {
      SupportText = "Unsupported Browser. Cannot Copy.";
    }); 
    
  };
</script>
<div class="join_community">

  <div class="container">
    <div class="row justify-content-center">            
      <div class="col-xl-8 col-lg-8 col-md-11 col-sm-11 col-12">
        <div class="common_home_section text-center">
          <h2>Join Our Community</h2>
          <p>We are Community Centric, Community Led, and Community Driven!   Check out the links to our social networks below and become a part of the DOE Army today!</p>                                
        </div>
        <div class="social_links">
          <div>
            <a href="https://twitter.com/KudoeOfficial" target="_blank" rel="noreferrer">
              <img class="normal_social" src="/img/images/twitter_small.svg" alt="icon"/>
              <img class="hover_socail" src="/img/images/twitter_hover.svg" alt="icon"/></a>
          </div>
          <div>
            <a href="https://t.me/KudoeOfficial" target="_blank" rel="noreferrer">
              <img class="normal_social" src="/img/images/telegram_small.svg" alt="icon"/>
              <img class="hover_socail" src="/img/images/telegram_hover.svg" alt="icon"/>
            </a>
          </div>
          <div>
            <a href="https://discord.gg/kudoe" target="_blank" rel="noreferrer">
              <img class="normal_social" src="/img/images/discord_small.svg" alt="icon"/>
              <img class="hover_socail" src="/img/images/discord_hover.svg" alt="icon"/>
            </a>
          </div>
          <div>
            <a href="https://www.instagram.com/dogsofelonofficial" target="_blank" rel="noreferrer">
              <img class="normal_social" src="/img/images/instagram_small.svg" alt="icon"/>
              <img class="hover_socail" src="/img/images/instagram_hover.svg" alt="icon"/>
            </a>
          </div>
          <div>
            <a href="https://kudoe.medium.com" target="_blank" rel="noreferrer">
              <img class="normal_social" src="/img/images/medium_small.svg" alt="icon"/>
              <img class="hover_socail" src="/img/images/medium_hover.svg" alt="icon"/>
            </a>
          </div>  
          <div>
            <a href="https://www.reddit.com/r/Kudoe/" target="_blank" rel="noreferrer">
              <img class="normal_social" src="/img/images/reddit_small.svg" alt="icon"/>
              <img class="hover_socail" src="/img/images/reddit_hover.svg" alt="icon"/>
            </a>
          </div>                              
        </div>
        <div class="copy_code">
          <img src="/img/images/dog_small.svg" alt="icon"/>
          <p>0xf8E9F10c22840b613cdA05A0c5Fdb59A4d6cd7eF</p> 
                         
          <span class="copybtn" on:click={toggle} class:isOpen><img src="/img/images/copy-thin.svg" alt="icon"/><p class="tooltip_p">{SupportText}</p></span>
        </div>
      </div>            
    </div>
  </div>
</div>

<style>
.copybtn{
  position:relative;
}
.tooltip_p{
  position:absolute;
  top:-35px;
  left:50%;
  transform: translate(-50%,0);
  white-space: nowrap;
  display:none;
  background:#212335;  
  padding: 4px 10px;
  font-size: 14px;
  border-radius: 5px;  
  box-shadow: 0 0 14px -2px #14141a;
}
.tooltip_p::after{
  content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 7px solid #212335;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: -6px;
}
.isOpen .tooltip_p{
  display:block;
}
</style>